import React from 'react';
import LoadingIndicator, { LoadingIndicatorProps } from '../LoadingIndicator/LoadingIndicator';
import { FullPage } from './FullPage';

const LoadingFullPage: React.FC<LoadingIndicatorProps> = props => {
  return (
    <FullPage>
      <LoadingIndicator {...props} />
    </FullPage>
  );
};

export default LoadingFullPage;
